<template>
<div class="mnp-commonly-brand-select-wrapper">
    <div class="headline">
      <slot name="headline"></slot>
    </div>
    <div class="selection-wrapper">
      <div class="first-row">
        <button v-if="brand1 !== null && brand1 !== ''" id="mnpin-common-provider-select-1" class="brand-select-button" @click="selected('1')">{{brand1}}</button>
        <button v-if="brand2 !== null && brand2 !== ''" id="mnpin-common-provider-select-2" class="brand-select-button" @click="selected('2')">{{brand2}}</button>
        <button v-if="brand3 !== null && brand3 !== ''" id="mnpin-common-provider-select-3" class="brand-select-button" @click="selected('3')">{{brand3}}</button>
      </div>
      <div class="second-row">
        <button v-if="brand4 !== null && brand4 !== ''" id="mnpin-common-provider-select-4" class="brand-select-button" @click="selected('4')">{{brand4}}</button>
        <button v-if="brand5 !== null && brand5 !== ''" id="mnpin-common-provider-select-5" class="brand-select-button" @click="selected('5')">{{brand5}}</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CheckoutMnpInCommonlyBrandSelect',
  data () {
    return {
    }
  },
  mixins: [
  ],
  computed: {
    brand1 () {
      return this.$slots.txtBrand1 && this.$slots.txtBrand1[0] ? this.$slots.txtBrand1[0].text : null
    },
    brand2 () {
      return this.$slots.txtBrand2 && this.$slots.txtBrand2[0] ? this.$slots.txtBrand2[0].text : null
    },
    brand3 () {
      return this.$slots.txtBrand3 && this.$slots.txtBrand3[0] ? this.$slots.txtBrand3[0].text : null
    },
    brand4 () {
      return this.$slots.txtBrand4 && this.$slots.txtBrand4[0] ? this.$slots.txtBrand4[0].text : null
    },
    brand5 () {
      return this.$slots.txtBrand5 && this.$slots.txtBrand5[0] ? this.$slots.txtBrand5[0].text : null
    }
  },
  methods: {
    selected (suffix) {
      const el = document.getElementById('mnpin-common-provider-select-' + suffix)
      if (el && el.innerText !== '') {
        this.$emit('selected', el.innerText)
      }
    }
  }
}
</script>
